import React from 'react';

import DialogBox from '../../components/shared/DialogBox';
import FormBuilder from '../../components/shared/FormBuilder';
import ClearanceFormData from './ClearanceFormData';

import BrokerageSelectSearchContainer from '../../components/shared/BrokerageSelectSearchContainer';

import isEmpty from 'lodash/isEmpty';
import ToastMessage, { toastify } from '../../components/shared/Toasts';

const stateRejectionMessage = (brokerageName,searchState,underwriterName)=>(
    <ToastMessage icon="info-circle">
        {brokerageName} is not authorized for projects in {searchState} State. Please reach out to {underwriterName} for any questions.
    </ToastMessage>
);

export default class ClearanceForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            requiredFields: [],
            validationModal: false,
            isBrokerageSelectedId: false,
            addressValues: {},
            scrollToRequiredFields: false,
            brokerageRequired: false,
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleValidationOk = this.handleValidationOk.bind(this);
        this.handleBrokerageChange = this.handleBrokerageChange.bind(this);
        this.handleAddressChange = this.handleAddressChange.bind(this);
        this.handleSetScrollToRequired = this.handleSetScrollToRequired.bind(this);
    }
    componentDidMount() {
        const { brokerId } = { ...this.props.person };
        this.setState({
            isBrokerageSelectedId: !isEmpty(brokerId)
        });
    };
    handleBrokerageChange(e) {
        let selectedBrokerage;
        let isBrokerageSelectedId;
        if (e === null) {
            selectedBrokerage = { brokerId: null };
            isBrokerageSelectedId = false;
        } else {
            selectedBrokerage = { brokerId: e.value };
            isBrokerageSelectedId = true;
        }

        this.setState(
            {
                isBrokerageSelectedId,
                newBrokerage: selectedBrokerage.brokerId
            },
            () => {
                this.props.onUpdateBrokerId(selectedBrokerage.brokerId);
            }
        );
    }

    handleAddressChange(updatedAddressValues,stateReject,searchState) {
        const addressValues = Object.assign(this.state.addressValues, updatedAddressValues);
        this.setState({
            addressValues
        });
        if(stateReject){
            const user = this.props.user;
            let brokerageName = ""
            if(user && user.brokerage){
                brokerageName = user.brokerage.name;
            }
            toastify.info(stateRejectionMessage(brokerageName,searchState,this.props.underwriterName));
        }        
    }

    handleSubmit(values, controlGroups, requiredFields) {
        const { isUnderwriter: hasUnderwriterPermission } = { ...this.props.person };
        const { isBrokerageSelectedId } = { ...this.state };
        if (requiredFields.length > 0 || (hasUnderwriterPermission && !isBrokerageSelectedId)) {
            this.setState({
                ...this.state,
                requiredFields,
                validationModal: true,
                brokerageRequired: !isBrokerageSelectedId,
                scrollToRequiredFields: true,
            });
        } else {
            this.setState({
                brokerageRequired: false,
                scrollToRequiredFields: false,
            });
            this.props.onSubmit(values);
        }
    }

    handleValidationOk() {
        this.setState({
            ...this.state,
            validationModal: false
        });
    }

    handleSetScrollToRequired = (scrollTo) => {
        this.setState({
            scrollToRequiredFields: scrollTo
        });
    };

    render() {
        const { isUnderwriter: hasUnderwriterPermission, brokerId } = { ...this.props.person };
        const { isUnderwriter } = this.props.person;
        const { isBrokerageSelectedId } = { ...this.state };
        let authStates = []
        if (!!this.props.user && !!this.props.user.brokerage) {
            authStates = !!this.props.user.brokerage.authStates && this.props.user.brokerage.authStates.length > 0 ? this.props.user.brokerage.authStates : true;
            ClearanceFormData.questions[10].attributes.authState = authStates;
        }
        const requiredList = () => {
            let errorBrokerageMessage = [];
            if (hasUnderwriterPermission && !isBrokerageSelectedId) {
                errorBrokerageMessage = (
                    <li key={`brokageLocation_${new Date().getTime()}`} className="remainingField">
                        Please insert the Brokerage Location
                    </li>
                );
            }
            let requiredListFrom = this.state.requiredFields.map((r, idx) => {
                const fieldText = r.questionId == '2c' ? 'State' : r.text;
                return (
                    <li key={idx} className="remainingField">
                        {fieldText ? fieldText : r.placeholder}
                    </li>
                );
            });
            return [errorBrokerageMessage, ...requiredListFrom];
        };
        return (
            <div className="container">
                <div className="row">
                    <div className="col-xs-12">
                        <h1>First Let&apos;s Check for Clearance.</h1>
                        <h4 className="non-fat">
                            Enter the following information to clear against previous submissions.
                        </h4>
                        <div className="mt-x2" />
                        {hasUnderwriterPermission && (
                            <div>
                                <div className="clearance_brokerage_dropdown pt mt">
                                    <div className="row">
                                        <div className="col-md-5">
                                            <div className={`subhead ${this.state.brokerageRequired && !isBrokerageSelectedId ? 'requiredLabel' : ''}`}>Brokerage Office</div>
                                            <BrokerageSelectSearchContainer
                                                value={brokerId}
                                                onChange={this.handleBrokerageChange}
                                                id="clearanceBrokerageDropdown"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        <FormBuilder
                            data={ClearanceFormData}
                            initialValues={this.props.values}
                            submitTitle="Check For Clearance"
                            handleSubmit={this.handleSubmit}
                            isUnderwriter={isUnderwriter}
                            authStates={authStates}
                            addressValues={this.state.addressValues}
                            handleAddressChange={this.handleAddressChange}
                            requiredFields={this.state.requiredFields}
                            scrollToRequiredFields={this.state.scrollToRequiredFields}
                            handleSetScrollToRequired={this.handleSetScrollToRequired}
                        />

                        <DialogBox
                            custom_class="confirmationDialog"
                            title="Please fill out all required fields."
                            show={this.state.validationModal}
                            onHide={this.handleValidationOk}
                        >
                            <div>
                                <h4>Here are your remaining questions:</h4>
                                <ul className="section">{requiredList()}</ul>

                                <br />
                                <div className="btn-group">
                                    <button
                                        type="button"
                                        className="btn btn-default"
                                        onClick={this.handleValidationOk}
                                    >
                                        Return to the Form
                                    </button>
                                </div>
                            </div>
                        </DialogBox>
                    </div>
                </div>
            </div>
        );
    }
}
